import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormInputComponent, SharedModule, StringCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
  selector: 'color-form-input',
  template: `
    <vdr-form-field [label]="'Color Picker'" class="clr-col-4">
        <input type="color" [formControl]="formControl">
    </vdr-form-field>
  `,
  standalone: true,
  imports: [SharedModule],
})
export class ColorFormInputComponent implements FormInputComponent<StringCustomFieldConfig>, OnInit {
  readonly: boolean;
  formControl: FormControl;
  config: StringCustomFieldConfig;
  ngOnInit() {
    const v = this.formControl?.value;
    if (v == null || v === '') {
      // default to white
      this.formControl.setValue('#ffffff', { emitEvent: false });
    }
  }
}